import SimpleBarChartXAxisTick from './SimpleBarChartXAxisTick';

export default SimpleBarChartXAxisTick;
